module.exports = __webpack_public_path__ + "img/spartan-roof-replacement-waterproofing-06.d5efff7d.jpg";